import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { List } from "entities/admin/model/slice/types";
import { GetCorporateClientsLookupParams, GetCorporateClientsLookupResponse } from "api/api/corporateClientsApi/types";
import { corporateClientsAPI } from "api/api/corporateClientsApi/corporateClientsApi";

export const getCorporateClientsLookup = createAsyncThunk<
  List<GetCorporateClientsLookupResponse>,
  GetCorporateClientsLookupParams
>("corporateClients/getCorporateClientsLookup", async (params, { rejectWithValue }) => {
  try {
    const data = await corporateClientsAPI.getCorporateClientsLookup(params);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while getting marathons lookup", error?.response?.data);
      return rejectWithValue(error?.response?.data || "Unknown error");
    } else {
      console.error("Error while getting marathons lookup", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
